import { useEffect } from "react";

/** Close a custom dialog with the Escape key. */
export default function useEscape(onClose) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
}
